import { NavLink } from "react-router";
import TraductionsList from "../../components/Traductions/TraductionsList";
import { useTrads } from "../../contexts/trads/useTrads";

function Traductions(){
  const {translate}=useTrads();
  return (
  <div>
    <nav>
        <NavLink to={`/traductions/add`} className="btn btn-primary mt-3">{translate('btn_add')}</NavLink>
    </nav>
    <TraductionsList   />
  </div>
  );
}
export default Traductions;